// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"245f5d1f","637":"0651c064"}[chunkId] + ".chunk.css";
};